const importProductsDictEN = {
  importProductsFromCSVFile: "Upload a .csv file below to import products from it",
  importTemplateExplanation:
    "ONLY basic data such as title, description, price, and images will be imported, you will still need to go over and review each resulting product and edit accordingly. Product variants are also not imported, and must be configured accordingly.",
  fringeBenefitDownloadedSuccessfully: "Fringe Benefit Downloaded Successfully",
  discharge: "Discharge",
  doYouWantToCancelTheProductBelow: "Do you want to cancel the voucher below?",
  wasDischargedFromFringeBenefit: "Was discharged from fringe benefit",
  associatedVoucher: "Associated voucher(s)"
};

export default importProductsDictEN;
